// Threshold (in seconds) below which a rack's pending deletion is surfaced in the
// UI — 1209600s = ~14 days. Used by the racks list, racks table, and rack details
// to decide when to show the inactivity-deletion banner / "marked for deletion" status.
export const DISPLAY_TIME_TO_DELETION_DURATION = 1209600;
export const PAST_DUE_DELETION_DATE = '09/08/2026'; // can be deleted after initial Deletion 09/08/2026
export const LRU_POWER_LABEL = 'LRU';
export const VM_POWER_LABEL = 'VM';
export const GATEWAY_POWER_LABEL = 'Gateway';
